import React from 'react';
import { useNavigate } from 'react-router-dom';

const TerminosCondiciones = () => {
  const navigate = useNavigate();

  const handleVolver = () => {
    navigate('/dashboard');
  };

  return (
    <div style={{ 
      backgroundColor: 'white', 
      minHeight: '100vh',
      padding: '2rem 0'
    }}>
      <div 
        className="container" 
        style={{ 
          maxWidth: '800px', 
          margin: '0 auto', 
          padding: '2rem',
          backgroundColor: 'white',
          color: 'black'
        }}
      >
      <div className="has-text-centered mb-6">
        <h1 className="title is-2 has-text-black">TÉRMINOS Y CONDICIONES</h1>
      </div>

      <div className="content has-text-black" style={{ lineHeight: '1.8', textAlign: 'left' }}>
        <h2 className="title is-4 has-text-black">Política de Protección de Datos Personales</h2>
        <h3 className="title is-5 has-text-black">Fundación Nigma Innovación y Futuro</h3>
        <h4 className="title is-6 has-text-black">2025</h4>

        <div className="mt-5">
          <h5 className="title is-5 has-text-black">1. Responsable del Tratamiento de Datos</h5>
          <p>
            De acuerdo con el Artículo 4 de la Ley Orgánica de Protección de Datos Personales, 
            la Fundación Nigma Innovación y Futuro, actúa como responsable del tratamiento de 
            los datos personales recopilados a través de nuestra página web.
          </p>

          <h5 className="title is-5 has-text-black mt-5">2. Datos Recopilados y Finalidad</h5>
          <p>
            En cumplimiento del Artículo 10 (Principios de Finalidad y Minimización de Datos), 
            recopilamos únicamente los datos personales necesarios para la gestión de donaciones 
            e información, que incluyen:
          </p>
          <ul>
            <li>Nombres y apellidos</li>
            <li>Dirección de correo electrónico</li>
            <li>Número de teléfono</li>
            <li>Información de pago (sin almacenar datos sensibles de tarjetas, conforme al Artículo 30, sobre datos relativos a la salud y financieros)</li>
          </ul>
          <p>
            Estos datos se tratarán exclusivamente para la gestión de donaciones y la comunicación 
            con los donantes, garantizando que no sean utilizados para fines distintos sin consentimiento 
            expreso (Artículo 12, Derecho a la Información).
          </p>

          <h5 className="title is-5 has-text-black mt-5">3. Base Legal del Tratamiento</h5>
          <p>
            Según el Artículo 7 (Tratamiento Legítimo de Datos), el tratamiento de datos personales 
            se realiza con base en:
          </p>
          <ul>
            <li>Consentimiento expreso del titular al aceptar los términos de uso de la plataforma.</li>
            <li>Ejecución de una obligación contractual cuando el titular se suscribe a un plan de donación.</li>
            <li>Cumplimiento de normativas legales en caso de auditorías o controles fiscales.</li>
          </ul>

          <h5 className="title is-5 has-text-black mt-5">4. Seguridad y Confidencialidad</h5>
          <p>
            En conformidad con el Artículo 37 (Seguridad de Datos Personales), implementamos 
            medidas técnicas y organizativas adecuadas para garantizar la seguridad e integridad 
            de los datos personales.
          </p>
          <p>
            Los datos son tratados bajo estricta confidencialidad y no se comparten con terceros 
            sin consentimiento previo, salvo en los siguientes casos previstos en el Artículo 36 
            (Excepciones al Consentimiento para la Transferencia de Datos):
          </p>
          <ul>
            <li>Cuando sea requerido por una autoridad competente.</li>
            <li>Cuando sea necesario para la ejecución del servicio (por ejemplo, procesadores de pago que cumplan con estándares de seguridad).</li>
          </ul>

          <h5 className="title is-5 has-text-black mt-5">5. Derechos del Titular de los Datos</h5>
          <p>
            De acuerdo con los Artículos 13 al 20, los titulares de los datos personales tienen derecho a:
          </p>
          <ul>
            <li>Acceder a la información almacenada sobre ellos (Artículo 13).</li>
            <li>Solicitar la rectificación o actualización de datos incorrectos (Artículo 14).</li>
            <li>Pedir la eliminación de sus datos cuando ya no sean necesarios para la finalidad original (Artículo 15).</li>
            <li>Oponerse al tratamiento de sus datos en ciertos casos (Artículo 16).</li>
            <li>Solicitar la portabilidad de sus datos a otro responsable (Artículo 17).</li>
          </ul>
          <p>
            Para ejercer estos derechos, los titulares pueden enviar una solicitud a 
            <a href="mailto:donaciones@fundacionnigma.org"> donaciones@fundacionnigma.org</a>, 
            y se les responderá dentro del plazo máximo de 15 días según lo estipula la ley.
          </p>

          <h5 className="title is-5 has-text-black mt-5">6. Conservación de los Datos</h5>
          <p>
            Los datos personales se conservarán únicamente por el tiempo necesario para cumplir 
            con la finalidad para la cual fueron recogidos, conforme al Artículo 10 (Principio de Conservación). 
            Posteriormente, serán eliminados de manera segura.
          </p>
          <p>
            En casos donde la legislación lo exija, ciertos datos podrán mantenerse por un tiempo 
            adicional para auditorías fiscales o contables.
          </p>

          <h5 className="title is-5 has-text-black mt-5">7. Transferencia de Datos y Encargados del Tratamiento</h5>
          <p>
            Según el Artículo 33, en caso de ser necesario, la Fundación Nigma podrá contratar 
            proveedores externos (plataformas de pago o servicios tecnológicos) que actuarán como 
            encargados del tratamiento, garantizando el cumplimiento de las normativas de protección de datos.
          </p>
          <p>Estos terceros estarán obligados contractualmente a:</p>
          <ul>
            <li>Tratar los datos exclusivamente para los fines acordados.</li>
            <li>Implementar medidas de seguridad adecuadas.</li>
            <li>No compartir la información con otros terceros sin autorización expresa.</li>
          </ul>

          <h5 className="title is-5 has-text-black mt-5">8. Contacto y Reclamaciones</h5>
          <p>
            Para cualquier consulta o reclamación sobre el tratamiento de datos personales, 
            los donantes pueden comunicarse con la Fundación Nigma a través de 
            <a href="mailto:donaciones@fundacionnigma.org"> donaciones@fundacionnigma.org</a> 
            y para información 
            <a href="mailto:info@fundacionnigma.org"> info@fundacionnigma.org</a> 
            o presentar una queja ante la Autoridad de Protección de Datos Personales en Ecuador, 
            en conformidad con el Artículo 24 (Ejercicio de Derechos).
          </p>
        </div>
      </div>

             <div className="has-text-centered mt-6">
         <button 
           className="button is-primary is-medium"
           onClick={handleVolver}
         >
           Volver al Dashboard
         </button>
       </div>
     </div>
   </div>
 );
};

export default TerminosCondiciones; 
